import React, { useState, useEffect, useRef } from 'react';
import { Carousel } from 'react-bootstrap';
import axios from 'axios';
import { buildApiUrl } from '../../config/api';
import 'bootstrap/dist/css/bootstrap.min.css';
import YouTube from 'react-youtube';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function VideoCarousel({ onConditionChange }) {
  const [videos, setVideos] = useState([]);
  const [index, setIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [cycling, setCycling] = useState(true);
  const [overlayVisible, setOverlayVisible] = useState([]); // Overlay für jedes Video
  const playersRef = useRef({});
  const timeOutRef = useRef(null);

  // Songs von der API laden
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const endpoint = buildApiUrl('/api/video');
        const response = await axios.get(endpoint);

        if (!Array.isArray(response.data)) {
          console.warn('Unexpected /api/video payload (expected array):', {
            endpoint,
            status: response.status,
            payloadType: typeof response.data,
            preview: typeof response.data === 'string' ? response.data.slice(0, 120) : response.data
          });
        }

        const nextVideos = Array.isArray(response.data) ? response.data : [];
        setVideos(nextVideos);
        setOverlayVisible(nextVideos.map(() => true)); // Overlay standardmäßig sichtbar
      } catch (err) {
        console.error('Error fetching Videos:', {
          endpoint: buildApiUrl('/api/video'),
          message: err?.message,
          status: err?.response?.status,
          data: err?.response?.data
        });
        setVideos([]);
        setOverlayVisible([]);
      } finally {
        setLoading(false);
      }
    };
    fetchVideos();
  }, []);

  useEffect(() => {
    if (!loading) {
      onConditionChange(videos.length > 0);
    }
  }, [loading, videos, onConditionChange]);


  const handleSelect = (selectedIndex) => {
    if ((selectedIndex - index + videos.length) % videos.length !== 1) {
      setCycling(false);
      clearTimeout(timeOutRef.current);
      timeOutRef.current = setTimeout(() => {
        setCycling(true);
      }, 7000);
    }
    Object.entries(playersRef.current).forEach(([key, player]) => {
      player.pauseVideo();
    });
    setIndex(selectedIndex);
  };

  if (loading) {
    return (
      <section id="videos" className="mysection">
        <SkeletonTheme baseColor="var(--home-skeleton-base-color)" highlightColor="var(--home-skeleton-highlight-color)">
          <div className="text-center mb-3">
            <Skeleton width={200} height={40} /> {/* Höhe ähnlich wie h2 */}
          </div>
          <div className="d-flex justify-content-center">
            <Skeleton width={640} height={390} />
          </div>
          <div className="mt-2 text-center">
            <Skeleton width={300} height={20} />
          </div>
        </SkeletonTheme>
      </section>
    );
  }


  const opts = {
    height: "390",
    width: "640",
    playerVars: {
      autoplay: 0,
    },
  };

  const onPlay = (id) => {
    clearTimeout(timeOutRef.current);
    setCycling(false);
    Object.entries(playersRef.current).forEach(([key, player]) => {
      if (key !== id && player.pauseVideo) {
        player.pauseVideo();
      }
    });
  };

  const onReady = (event, id) => {
    clearTimeout(timeOutRef.current);
    playersRef.current[id] = event.target;
    console.log("player loaded: ", id);
  };

  const handleOverlayClick = (idx) => {
    console.log("Overlay clicked on video idx:", idx);
    setOverlayVisible((prev) =>
      prev.map((v, i) => (i === idx ? false : v)) // Overlay ausblenden
    );
    const player = playersRef.current[videos[idx].ytId];
    if (player && player.playVideo) {
      player.playVideo(); // optional Video starten
    }
    setCycling(false);
  };

  const onPause = () => {
    clearTimeout(timeOutRef.current);
    timeOutRef.current = setTimeout(() => {
      setCycling(true);
    }, 7000);
  };

  return (
    <section
      id="videos"
      className="mysection"
    >
      <h2 className='heading'>VIDEOS</h2>
      <Carousel
        id="ytcarousel"
        className="myCarousel"
        activeIndex={index}
        onSelect={handleSelect}
        interval={cycling ? 3000 : null}
        controls={false}
        indicators={true}
        pause={false}
      >
        {videos.map((video, idx) => (
          <Carousel.Item key={idx}>
            <div style={{ position: "relative", width: "100%", height: "390px" }}>
              <YouTube
                style={{
                  display: "flex",
                  justifyContent: "center",
                  paddingRight: "20px",
                  paddingLeft: "20px",
                }}
                videoId={video.ytId}
                opts={opts}
                onReady={(e) => onReady(e, video.ytId)}
                onPlay={() => onPlay(video.ytId)}
                onPause={onPause}
              />
              {overlayVisible[idx] && (
                <div
                  onClick={() => handleOverlayClick(idx)}
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    cursor: "pointer",
                    backgroundColor: "transparent",
                  }}
                />
              )}
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </section>
  );
}
